(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["td-quick-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-quick-view-button')) {
  class TDQuickViewButton extends HTMLElement {
    constructor() {
      super();

      this.originalText = this.textContent.trim();
      this.boundHandleClick = this.handleClick.bind(this);
      this.boundEndLoading = this.endLoading.bind(this);
    }
    
    connectedCallback() {
      this.addEventListener('click', this.boundHandleClick);
      document.addEventListener('modal:open', this.boundEndLoading);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleClick);
      document.removeEventListener('modal:open', this.boundEndLoading);
    }
    
    handleClick(event) {
      event.preventDefault();
      this.setLoading('Loading...');

      const productHandle = this.dataset.productHandle;
      if (productHandle) {
        this.dispatchEvent(new CustomEvent('quick-view-button-click', { 
          detail: { productHandle },
          bubbles: true 
        }));
      }
    }

    setLoading(text) {
      this.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.classList.add('td-quick-view-block__view-button--loading');
      this.textContent = text;
    }

    endLoading() {
      this.disabled = false;
      this.setAttribute('aria-busy', 'false');
      this.classList.remove('td-quick-view-block__view-button--loading');
      this.textContent = this.originalText;
    }
  }

  customElements.define('td-quick-view-button', TDQuickViewButton);
}
  } catch(e) { console.error(e); }
})();

})();
